module.exports = __webpack_public_path__ + "h5/img/rexian.682f1b66.png";